import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type SigningStatus = {
    signingStatus: string;
    waitingFor: string;
};

export const getSigningStatus = async (
    apiProxyPath: string,
    apiKey: string,
    arn: string | undefined,
    authenticationData?: AuthenticationData,
): Promise<SigningStatus> => {
    return apiClient<SigningStatus>(`${apiProxyPath}/application/${arn}/signing_status`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_signing_status',
        sentryExtra: { arn },
    });
};
